"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tabheader = _interopRequireDefault(require("../controls/tabheader"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _hooks = require("../hooks");

var Top = function Top(_ref) {
  var showLogosTab = _ref.showLogosTab,
      showAddImageButton = _ref.showAddImageButton,
      actions = _ref.actions;

  var _useActiveView = (0, _hooks.useActiveView)(),
      currentView = _useActiveView.currentView;

  return /*#__PURE__*/_react["default"].createElement(_tabheader["default"], {
    showSearch: currentView === 'free-images',
    disabled: currentView === 'upload' || currentView === 'image-details',
    showLogosTab: showLogosTab,
    showAddImageButton: showAddImageButton,
    actions: actions
  });
};

Top.propTypes = {
  showLogosTab: _propTypes["default"].bool,
  showAddImageButton: _propTypes["default"].bool,
  actions: _propTypes["default"].array
};

var _default = (0, _withContext["default"])(Top);

exports["default"] = _default;